<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>離職單填寫</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>聘用資料填寫</span></li>
          <li><span>離職單填寫</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號：</label>
                <div class="col-md-4">{{item.studentId}}</div>
                <label class="col-md-2 control-label">姓　　名：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">班　　級：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
                <label class="col-md-2 control-label">聘僱單位：</label>
                <div class="col-md-4">{{item.deptName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">到職日<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4"><input type="date" v-model="form.employDate"></div>
                <label class="col-md-2 control-label">擬離職日期<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4"><input type="date" v-model="form.resignDate"></div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">擬離職原因<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">
                  <select v-model="form.resignReason">
                    <option value="">請選擇</option>
                    <option value="休學">休學</option>
                    <option value="退學">退學</option>
                    <option value="畢業">畢業</option>
                    <option value="其他">其他</option>
                  </select>
                  <input type="text" placeholder="其他原因" v-model="form.resignReasonOther" v-show="form.resignReason=='其他'">
                </div>

              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">說　　明<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-10"><textarea style="width:100%" rows="5" v-model="form.resignRemark"></textarea></div>
              </div>
              <label class="col-md-2 control-label">填表日期：</label>
              <div class="col-md-4">{{item.createDate}}</div>
              <table width="100%" v-if="isResign==false">
                <tr>
                  <td align="right"><a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
                  <td align="left"><a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a></td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        employDate: "",
        resignDate: "",
        resignReason: "",
        resignReasonOther: "",
        resignRemark: ""
      },
      isResign: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyStudent/resign/" + this.id).then(a => {
        this.item = a.body;
        if (a.body.workstudyResignId) {
          this.isResign = true;
          this.form.employDate = a.body.employDate;
          this.form.resignDate = a.body.resignDate;
          this.form.resignReason = a.body.resignReason;
          this.form.resignReasonOther = a.body.resignReasonOther;
          this.form.resignRemark = a.body.resignRemark;
        }
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudyStudent/resign/" + this.id, this.form).then(a => {
        if (a.body.status) {
          alert("離職單資料已填寫完成，若有問題請聯繫聘用單位。");
          this.$router.push("/student");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    formClear() {
      this.form.employDate = "";
      this.form.resignDate = "";
      this.form.resignReason = "";
      this.form.resignReasonOther = "";
      this.form.resignRemark = "";
    },
    checkForm() {
      let msg = "";
      if (this.form.employDate == "") msg += "『到職日』、";
      if (this.form.resignDate == "") msg += "『擬離職日期』、";
      if (this.form.resignReason == "") msg += "『擬離職原因』、";
      if (this.form.resignReason == "其他" && this.form.resignReasonOther == "") msg += "『擬離職原因-其他內容』、";
      if (this.form.resignRemark == "") msg += "『說明』、";
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未填寫");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>